import { Button, IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { ChromePicker } from 'react-color';
import SellIcon from '@mui/icons-material/Sell';
interface Tag {
	name: string;
	web_inbox_color: string | undefined;
}

interface ColorObject {
	hex: string;
	rgb: {
		r: number;
		g: number;
		b: number;
		a?: number;
	};
	hsl: {
		h: number;
		s: number;
		l: number;
		a?: number;
	};
}

interface Props {
	operation: 'create' | 'update';
	allTags: [];
	setAllTags: (data: []) => void;
	editableTag: any;
	listTags: () => void;
}

const popover: React.CSSProperties = {
	position: 'fixed',
	zIndex: '9999',
};

const cover: React.CSSProperties = {
	position: 'fixed',
	top: '0px',
	right: '0px',
	bottom: '0px',
	left: '0px',
};

const CustomTagField = ({ operation, allTags, setAllTags, editableTag, listTags }: Props) => {
	const { apiService }: any = React.useContext(ApplicationContext);

	//Color Picker States
	const [open, setOpen] = useState(false);

	//Field States
	const [tagField, setTagField] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [errorMessage, setErrorMessage] = useState<string>('');
	const [disableInput, setDisableInput] = useState(false);
	const [tag, setTag] = useState<Tag>({
		name: editableTag?.name || '',
		web_inbox_color: editableTag?.web_inbox_color || '#6f7385',
	});

	const handleColorChange = (newColor: ColorObject) => {
		setTag({ ...tag, web_inbox_color: newColor?.hex });
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		if (operation === 'create') {
			setError(false);
			setErrorMessage('');
		} else {
			let data: any = allTags?.map((tag: any) => {
				if (editableTag?.id === tag?.id) {
					return { ...tag, error: false };
				}
				return tag;
			});
			setAllTags(data);
		}
		setTag({ ...tag, name: e.target.value });
	};

	const addTag = () => {
		try {
			let data: any = [...allTags];
			setDisableInput(true);
			apiService.createTagV2(
				tag,
				(response: any) => {
					if (response) {
						//next req
						listTags();

						data.push({ ...response?.data?.data, id: response?.data?.data?._id });
						setAllTags(data);
						setTagField(false);
						setTag({
							name: editableTag?.name || '',
							web_inbox_color: editableTag?.web_inbox_color || '#6f7385',
						});
						setDisableInput(false);
					}
				},
				() => {
					setError(true);
					setErrorMessage('Something went wrong! Please Try Again');
					setDisableInput(false);
				}
			);
		} catch (err) {}
	};

	const updateTag = () => {
		setDisableInput(true);
		apiService.updateTagV2(
			editableTag?.id || editableTag?._id,
			tag,
			(response: any) => {
				//next req
				listTags();

				const data: any = allTags?.map((chatTag: any) => {
					if (editableTag?.id === chatTag?.id) {
						return { ...response?.data?.data, editView: false, id: response?.data?.data?._id };
					}
					return chatTag;
				});
				setAllTags(data);
				setError(true);
				setErrorMessage('Something went wrong! Please Try Again');
				setDisableInput(false);
			},
			() => {
				const data: any = allTags?.map((tag: any) => {
					if (editableTag?.id === tag?.id) {
						return { ...tag, error: true };
					}
					return tag;
				});
				setAllTags(data);
				setDisableInput(false);
			}
		);
	};

	const cancelEditView = () => {
		const data: any = allTags?.map((chatTag: any) => {
			if (editableTag?.id === chatTag?.id) {
				return { ...chatTag, editView: false };
			}
			return chatTag;
		});
		setAllTags(data);
	};
	return (
		<>
			{operation === 'create' ? (
				<div
					style={
						tagField
							? { marginTop: '2px', width: '100%', position: 'relative' }
							: {
									marginTop: '2px',
									width: '100%',
									display: 'flex',
									justifyContent: 'flex-end',
									position: 'relative',
							  }
					}
				>
					{tagField ? (
						<div style={{ display: 'flex', alignItems: 'center' }}>
							{open ? (
								<div style={popover}>
									<div style={cover} onClick={() => setOpen(false)} />
									<ChromePicker color={tag?.web_inbox_color} onChange={handleColorChange} />
								</div>
							) : (
								<SellIcon
									onClick={() => setOpen(!open)}
									style={{
										fill: tag.web_inbox_color,
										cursor: 'pointer',
									}}
								/>
							)}
							<TextField
								variant="standard"
								sx={{ transition: '0.3s ease-in-out' }}
								value={tag?.name}
								placeholder="Create New Tag"
								onChange={(e) => handleChange(e)}
								disabled={disableInput}
								error={error}
								helperText={errorMessage}
								size="medium"
								fullWidth={true}
								autoFocus={true}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													setTagField(false);
													setTag({
														name: editableTag?.name || '',
														web_inbox_color: editableTag?.web_inbox_color || '#6f7385',
													});
													setError(false);
													setErrorMessage('');
												}}
												color="primary"
												aria-label="Cancel"
											>
												<CloseIcon />
											</IconButton>
											<IconButton
												onClick={addTag}
												color="primary"
												disabled={!tag?.name?.trim()?.length}
												aria-label="Save"
											>
												<DoneIcon />
											</IconButton>
										</InputAdornment>
									),
								}}
								onKeyDown={(e) => {
									if (e.key === 'Enter' && tag?.name?.trim()?.length > 0) {
										addTag();
									}
								}}
							/>{' '}
						</div>
					) : null}
					{!tagField ? (
						<Button
							style={{ display: 'flex', justifyContent: 'flex-end' }}
							onClick={() => setTagField(true)}
							color="primary"
							variant="contained"
						>
							Create Tag
						</Button>
					) : null}
				</div>
			) : (
				<div style={{ display: 'flex', alignItems: 'center', gap: '3px', marginTop: '2px' }}>
					{open ? (
						<div style={popover}>
							<div style={cover} onClick={() => setOpen(false)} />
							<ChromePicker color={tag?.web_inbox_color} onChange={handleColorChange} />
						</div>
					) : (
						<SellIcon
							onClick={() => setOpen(!open)}
							style={{
								fill: tag.web_inbox_color,
								cursor: 'pointer',
							}}
						/>
					)}
					<TextField
						variant="standard"
						sx={{ transition: '0.3s ease-in-out', flexGrow: 1 }}
						value={tag?.name}
						placeholder="Update Tag"
						onChange={(e) => handleChange(e)}
						disabled={disableInput}
						error={editableTag?.error}
						helperText={editableTag?.error ? 'Something went wrong! Please Try Again' : null}
						size="medium"
						autoFocus={true}
						onKeyDown={(e) => {
							if (e.key === 'Enter' && tag?.name?.trim()?.length > 0) {
								addTag();
							}
						}}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton onClick={cancelEditView} color="primary" aria-label="Cancel">
										<CloseIcon />
									</IconButton>
									<IconButton
										onClick={updateTag}
										color="primary"
										disabled={!tag?.name?.trim()?.length}
										aria-label="Save"
									>
										<DoneIcon />
									</IconButton>
								</InputAdornment>
							),
						}}
					/>
				</div>
			)}
		</>
	);
};

export default CustomTagField;
